/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @version 1.0.1
 * @since 1.0.0
 */
import styled from 'styled-components';

import { colors } from '../../../../../../theme';

export const ExtFilterValueContainerStyled = styled.div.attrs({
    className: 'ext-filter__value',
})<{showValue: boolean}>`
    display: ${({ showValue }) => showValue ? 'flex' : 'none'};
    flex-wrap: nowrap;
    justify-content: space-between;
    padding: 18px 16px 10px;
    margin-bottom: 40px;
    background-color: ${colors.backgroundColorModal};
`;
export const ExtFilterValueItemListStyled = styled.div.attrs({
    className: 'ext-filter__value-item-list',
})`
    display: flex;
    flex-wrap: wrap;
`;
export const ExtFilterValueItemStyled = styled.div.attrs({
    className: 'ext-filter__value-item',
    tabIndex: 0,
})`
    max-width: 400px;
    width: auto;
    display: flex;
    margin-right: 8px;
    padding: 2px 12px;
    margin-bottom: 8px;
    outline: none;
    border-radius: 14px;
    background: ${colors.backgroundColorDisabled};
    cursor: pointer;
`;
export const ExtFilterValueAndStyled = styled.div.attrs({
    className: 'ext-filter__value-and',
})`
    display: inline-block;
    vertical-align: top;
    margin-bottom: 8px;
    padding: 2px 0;
    margin-right: 8px;
`;
export const ClearExtFilterStyled = styled.div.attrs({
    'className': 'ext-filter__clear-filter',
    'data-ext-filter': 'ext-filter',
})`
    height: 25px;
    margin-left: 24px;
    display: flex;
    flex-wrap: nowrap;
    align-self: flex-start;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    & .text-block {
        white-space: nowrap;
    }
`;
